var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 19,
    r: 16,
    fill: "#1f576e",
    className: "color1f576e svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d0e6f4",
    d: "M38 18v-4a2 2 0 0 1 2 2 1 1 0 0 0 2 0 4 4 0 0 0-4-4v-1a1 1 0 0 0-2 0v1a4 4 0 0 0 0 8v4a2 2 0 0 1-2-2 1 1 0 0 0-2 0 4 4 0 0 0 4 4v1a1 1 0 0 0 2 0v-1a4 4 0 0 0 0-8zm-4-2a2 2 0 0 1 2-2v4a2 2 0 0 1-2-2zm4 8v-4a2 2 0 0 1 0 4zm20.036 9.11a4.1 4.1 0 0 0-3.433.73l-13.3 10.313A9.993 9.993 0 0 1 37 46.07v-2.99a3.9 3.9 0 0 0-2.9-3.73l-7.16-1.98a10.336 10.336 0 0 0-7.54.81L8 44.311V58l10.455-2.027h19.71a10 10 0 0 0 6.856-2.72l14.831-13.968a3.61 3.61 0 0 0-1.816-6.175z",
    className: "colord0e6f4 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6db2c1",
    d: "M37 44.039v2.029a10.224 10.224 0 0 1-1.84.161 11.417 11.417 0 0 1-1.84-.15l-7.5-1.29a1 1 0 0 1 .34-1.981l7.5 1.291a8.925 8.925 0 0 0 3.34-.06Z",
    className: "color6db2c1 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4699b7",
    d: "m3 61 8-.813a2.12 2.12 0 0 0 2-2.15l-.869-15.09a2.221 2.221 0 0 0-2.791-1.885L3 42.512Z",
    className: "color4699b7 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyExchange);
export default __webpack_public_path__ + "static/media/moneyExchange.e632b236f2db76be77ab1f2b1ff8967f.svg";
export { ForwardRef as ReactComponent };